
























































import { db, firestore ,functions,auth, authObject} from "@/scripts/firebase";
//import { User } from "@/scripts/datatypes";
import { Component,Mixins } from "vue-property-decorator";
import Common from '@/mixins/common'

@Component

/**
 * ひらがなに制限
 */

export default class AddUserBulk extends Mixins(Common) {
  isLoading = false
  isImporting = false
  columns = [
    {
      field: 'email',
    },
    {
      field: 'displayName',
    },
    {
      field: 'lastName',
    },
    {
      field: 'lastNameYomigana',
    },
     {
      field: 'firstName',
    },
    {
      field: 'firstNameYomigana',
    },
    {
      field: 'role',
    }
  ]
  csvFile? = null
  userList = [] as any

  async importUser(){
    try{
      this.$store.commit("setLoading",true)
      this.isImporting = true
      const lang = this.$store.getters.userLang
      const createUser = functions.httpsCallable('createUser')
      const getUsers = functions.httpsCallable('getUsers')
      const addUser = functions.httpsCallable('addUser')

      const usersPublicProfile = await this.$getUsersPublicProfileQuery().get()

      await Promise.all(this.userList.map(async (val: any,index: number) => {
        try{
          let userRecord = null
          let userAuthData = null
          let emailAlreadyExists = false
          let displayNameAlreadyExists = false

          if(! (typeof val.email === 'string') || val.email.length <= 5){
            val.email = undefined
          }

          if(! val.lang){
            val.lang = lang
          }

          if(typeof val.email === 'string' && val.email.length >= 5){
            userAuthData = await getUsers({identifiers: [{email: val.email}], schoolId: this.$store.getters.schoolId})
            if(userAuthData !== null && userAuthData.data && Object.keys(userAuthData.data).length === 1){
              this.$set(val,'result',this.$t('addUser.emailAlreadyMember'))
              return Promise.resolve(true)
            }
          }
        
          if(typeof val.displayName === 'string' && val.displayName.length >= 1){
            displayNameAlreadyExists = usersPublicProfile.docs.some((doc) =>{
              const d = doc.data()
              if(d.displayName && (d.displayName === val.displayName)){
                return true
              }
              return false
            })

            if(displayNameAlreadyExists){
              this.$set(val,'result',this.$t('addUser.displayNameAlreadyMember'))
              return Promise.resolve(true)
            }
          }

          try{
            userRecord = await createUser({schoolId: this.$store.getters.schoolId, ...val})
          }catch(error){
            const errorCode = this.$getErrorCode(error)
            if(errorCode === 'auth/email-already-exists'){
              emailAlreadyExists = true
              userRecord = await addUser({schoolId: this.$store.getters.schoolId, ...val})
            }
          }

          if(userRecord && userRecord.data.uid){
            if(userRecord.data.email){
              const sendMail = functions.httpsCallable('sendEmail');
              const data = {
                uid: userRecord.data.uid,
                schoolId: this.$store.getters.schoolId,
                actionType: 'passwordReset',
                template: 'welcomToMaritoMail'
              }

              if(emailAlreadyExists){//メール確認いらない
                data.actionType = 'sendEmail'
                data.template = 'welcomToSchoolMail'
              }

              try{
                const sentMail = await sendMail(data)
                this.$set(val,'result',this.$t('addUser.addedUserAndSentEmail'))
              }catch(error){
                this.$set(val,'result',this.$t('addUser.added'))
              }
            }else{
              this.$set(val,'result',this.$t('addUser.added'))
            }
          }
        }catch(error){
          this.$set(val,'result',this.$t('addUser.unableToAddUser'))
        }
        Promise.resolve(true)
      }))
    }finally{
      this.$store.commit("setLoading",false);
      this.isImporting = false
    }  
  }

  async readUserList(event: any){
    if(event.target.files[0]){
      this.$store.commit("setLoading",true);
      this.isLoading = true

      this.csvFile = (event.target.files[0])
      console.log(this.csvFile)
    
      const reader = new FileReader();
      reader.readAsText(this.csvFile as any)

      console.log(reader)

      this.userList = await new Promise(resolve =>{
        reader.onload = (() => {
          const data: Array<any> = []
          let lines: Array<string> = []
          const columns: Array<any> = []
          const labels: Array<string> = []
          const order = [] as any
          if(reader.result){
            lines = (reader.result as string).split(/[\n\r]+/)
            
            lines.forEach((line) => {
              columns.push(line.split(','))
            })

            const labels = columns.shift()

            this.columns.forEach((column) => {
              const field = column.field as keyof typeof order
              const index = labels.indexOf(field)
              if(index > -1){
                order[index] = field
              }
            })

            columns.forEach(column =>{
              const line = {} as any
              order.forEach((field: string,index: number) =>{
                line[field] = column[index]
              })
              if(! line.role){
                line.role = 'student'
              }
              data.push(line)
            })
            resolve(data)
          }
        })
      })

      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  created(){
    console.trace('created')
  }

  destroyed() {
    console.trace('destroyed');
  }
}
